export default __webpack_public_path__ + "static/media/ISMO SYLLABUS_2026-27 CLASS 4.96af04b0.pdf";